// export const getCloudfrontUrl = (s3Url) => {
//   if (!s3Url) return "";

//   const s3Bases = [
//     "https://prismprodnew.s3.us-east-1.amazonaws.com",
//     "https://prismprodnew.s3.amazonaws.com",
//   ];

//   const cloudfrontBase = "https://d1jzpuh6ctcnd2.cloudfront.net";

//   for (const base of s3Bases) {
//     if (s3Url.startsWith(base)) {
//       return s3Url.replace(base, cloudfrontBase);
//     }
//   }

//   return s3Url; // fallback if no match
// };

export const getCloudfrontUrl = (value) => {
  if (!value) return "";

  const cloudfrontBase = "https://d1jzpuh6ctcnd2.cloudfront.net";

  if (value.startsWith(cloudfrontBase)) {
    return value;
  }

  const s3Bases = [
    "https://prismprodnew.s3.us-east-1.amazonaws.com",
    "https://prismprodnew.s3.amazonaws.com",
    "https://prismmumbaibucket.s3.ap-south-1.amazonaws.com",
    "https://prismmumbaibucket.s3.amazonaws.com",
  ];

  for (const base of s3Bases) {
    if (value.startsWith(base)) {
      return value.replace(base, cloudfrontBase);
    }
  }

  if (!value.startsWith("http")) {
    return `${cloudfrontBase}/${value.replace(/^\/+/, "")}`;
  }

  return value;
};
